(function () {
  'use strict';

  var STORAGE_KEY = 'florame_haptics_enabled';
  var INSTALLED_KEY = '__florameHapticInteractionsInstalled';
  var TOGGLE_ID = 'florameHapticsToggle';
  var MOVE_THRESHOLD = 10;
  var SCROLL_THRESHOLD = 4;

  function hapticsSupported() {
    try {
      if (typeof navigator === 'undefined' || typeof navigator.vibrate !== 'function') return false;
      var userAgent = String(navigator.userAgent || '');
      var isIos = /iPad|iPhone|iPod/i.test(userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
      var isMobile = navigator.userAgentData && typeof navigator.userAgentData.mobile === 'boolean'
        ? navigator.userAgentData.mobile
        : /Android|Mobi/i.test(userAgent);
      return !isIos && isMobile;
    } catch (_) {
      return false;
    }
  }

  function hapticsEnabled() {
    try {
      return localStorage.getItem(STORAGE_KEY) !== '0';
    } catch (_) {
      return true;
    }
  }

  function setHapticsEnabled(enabled) {
    var next = hapticsSupported() && enabled !== false;
    try {
      localStorage.setItem(STORAGE_KEY, next ? '1' : '0');
    } catch (_) {}
    try {
      window.dispatchEvent(new CustomEvent('florame:hapticschange', { detail: { enabled: next } }));
    } catch (_) {}
    updateToggle();
    return next;
  }

  function vibrate(pattern) {
    if (!hapticsSupported() || !hapticsEnabled()) return;
    try {
      navigator.vibrate(pattern);
    } catch (_) {}
  }

  function updateToggle() {
    var toggle = document.getElementById(TOGGLE_ID);
    if (!toggle) return;
    toggle.hidden = !hapticsSupported();
    if (toggle.hidden) return;
    var enabled = hapticsEnabled();
    toggle.setAttribute('aria-checked', enabled ? 'true' : 'false');
    toggle.classList.toggle('is-on', enabled);
    var state = toggle.querySelector('[data-haptics-state]');
    if (state) state.textContent = enabled ? 'ON' : 'OFF';
    var copy = toggle.querySelector('[data-haptics-copy]');
    if (copy) copy.textContent = enabled ? 'Feedback tattile attivo' : 'Solo animazioni visive';
  }

  function handleToggleClick(event) {
    if (event) {
      if (event.__florameHapticsHandled) return;
      event.__florameHapticsHandled = true;
      event.preventDefault();
      event.stopPropagation();
    }
    var enabled = setHapticsEnabled(!hapticsEnabled());
    if (enabled) vibrate([12, 24, 12]);
  }

  function getTargetMenu() {
    if (document.querySelector('[data-florame-account-center]')) return null;
    return document.getElementById('profileOptions');
  }

  function createToggle(accountMenu) {
    var existing = document.getElementById(TOGGLE_ID);
    if (!hapticsSupported()) {
      if (existing && existing.parentNode) {
        var unsupportedSeparator = existing.previousElementSibling;
        if (unsupportedSeparator && unsupportedSeparator.classList && unsupportedSeparator.classList.contains('florame-haptics-sep')) {
          unsupportedSeparator.remove();
        }
        existing.remove();
      }
      return;
    }
    if (!accountMenu) {
      updateToggle();
      return;
    }

    if (existing && accountMenu.contains(existing)) {
      updateToggle();
      return;
    }

    if (existing && existing.parentNode) {
      var previous = existing.previousElementSibling;
      if (previous && previous.classList && previous.classList.contains('florame-haptics-sep')) {
        previous.remove();
      }
      existing.remove();
    }

    var toggle = document.createElement('button');
    toggle.type = 'button';
    toggle.id = TOGGLE_ID;
    toggle.className = 'profile-menu-item profile-menu-item--haptics florame-haptics-toggle';
    toggle.setAttribute('role', 'menuitemcheckbox');
    toggle.innerHTML = [
      '<span class="profile-menu-ic profile-menu-ic--haptics" aria-hidden="true">',
      '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">',
      '<path d="M8 2h8a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2Z"></path>',
      '<path d="M12 18h.01"></path>',
      '<path d="m3 8-1 1 1 1"></path>',
      '<path d="m21 8 1 1-1 1"></path>',
      '<path d="m3 14-1 1 1 1"></path>',
      '<path d="m21 14 1 1-1 1"></path>',
      '</svg>',
      '</span>',
      '<span class="profile-menu-text"><span class="profile-menu-title">Vibrazione</span><span class="profile-menu-sub" data-haptics-copy>Feedback tattile attivo</span></span>',
      '<span class="profile-menu-switch" aria-hidden="true"><span></span></span>'
    ].join('');

    toggle.addEventListener('click', handleToggleClick);

    var anchor = accountMenu.querySelector('[data-florame-push-menu-toggle], .profile-menu-item--notifications, .profile-menu-item');
    accountMenu.insertBefore(toggle, anchor || null);
    updateToggle();
  }

  function installToggleObserver() {
    function sync() {
      createToggle(getTargetMenu());
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', sync, { once: true });
    } else {
      sync();
    }

    window.addEventListener('florame:accountmenu-ready', sync);
    window.addEventListener('florame:haptics-sync-toggle', sync);
    document.addEventListener('click', function (event) {
      var toggle = event.target && event.target.closest ? event.target.closest('#' + TOGGLE_ID) : null;
      if (toggle) handleToggleClick(event);
    }, true);

    var attempts = 0;
    var retry = window.setInterval(function () {
      attempts += 1;
      sync();
      if (!hapticsSupported() || document.getElementById(TOGGLE_ID) || attempts >= 20) {
        window.clearInterval(retry);
      }
    }, 250);
  }

  function installInteractions() {
    if (!hapticsSupported()) return;
    if (window[INSTALLED_KEY]) return;
    window[INSTALLED_KEY] = true;

    var selector = [
      'button',
      'a[href]',
      '[role="button"]',
      '[role="menuitem"]',
      '[role="option"]',
      '[role="tab"]',
      'summary',
      'select',
      'label[for]',
      'input[type="button"]',
      'input[type="submit"]',
      'input[type="reset"]',
      'input[type="checkbox"]',
      'input[type="radio"]',
      '.button',
      '.btn',
      '.shopify-payment-button__button',
      '.product-form__submit',
      '.quantity__button',
      '.cart-remove-button',
      '.share-button__button',
      '.slider-button',
      '.nav-item',
      '.option-card',
      '.flower-card',
      '.budget-card',
      '.profile-menu-item',
      '.account-option',
      '.theme-option'
    ].join(',');

    var pendingTap = null;

    document.addEventListener('pointerdown', function (event) {
      if (event.pointerType === 'mouse' && event.button !== 0) return;
      var target = event.target && event.target.closest ? event.target.closest(selector) : null;
      if (!target || target.disabled || target.getAttribute('aria-disabled') === 'true') return;
      pendingTap = {
        target: target,
        pointerId: event.pointerId,
        x: event.clientX || 0,
        y: event.clientY || 0,
        scrollX: window.scrollX || window.pageXOffset || 0,
        scrollY: window.scrollY || window.pageYOffset || 0
      };
    }, { passive: true, capture: true });

    document.addEventListener('pointercancel', function (event) {
      if (pendingTap && pendingTap.pointerId === event.pointerId) pendingTap = null;
    }, { passive: true, capture: true });

    document.addEventListener('pointerup', function (event) {
      if (!pendingTap || pendingTap.pointerId !== event.pointerId) return;
      var tap = pendingTap;
      pendingTap = null;
      if (!tap.target || !tap.target.isConnected) return;
      var moved = Math.hypot((event.clientX || 0) - tap.x, (event.clientY || 0) - tap.y);
      if (moved > MOVE_THRESHOLD) return;
      var scrollDelta = Math.abs((window.scrollX || window.pageXOffset || 0) - tap.scrollX) +
        Math.abs((window.scrollY || window.pageYOffset || 0) - tap.scrollY);
      if (scrollDelta > SCROLL_THRESHOLD) return;
      vibrate([8]);
    }, { passive: true, capture: true });
  }

  window.FlorameHaptics = Object.assign({}, window.FlorameHaptics || {}, {
    supported: hapticsSupported,
    enabled: hapticsEnabled,
    setEnabled: setHapticsEnabled,
    vibrate: vibrate,
    syncToggle: updateToggle
  });

  installInteractions();
  installToggleObserver();
  window.addEventListener('florame:hapticschange', updateToggle);
})();
